import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from './locales/en/translation.json';
import bgTranslations from './locales/bg/translation.json';
import nlTranslations from './locales/nl/translation.json';
import trTranslations from './locales/tr/translation.json';
import plTranslations from './locales/pl/translation.json';
import { supportedLanguages } from './constants/languages';

export { supportedLanguages };
export type { AppLanguage } from './constants/languages';

const savedLanguage = localStorage.getItem('i18nextLng') || 'nl';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      bg: { translation: bgTranslations },
      en: { translation: enTranslations },
      nl: { translation: nlTranslations },
      tr: { translation: trTranslations },
      pl: { translation: plTranslations },
    },
    lng: savedLanguage,
    supportedLngs: [...supportedLanguages],
    fallbackLng: 'nl',
    debug: false,
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false
    },
    defaultNS: 'translation',
    ns: ['translation'],
  });

export const changeLanguage = (language: string) => {
  i18n.changeLanguage(language);
  localStorage.setItem('i18nextLng', language);
};

export default i18n;
